import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { motion } from 'framer-motion';
export function Hero() {
  return <Section background="gradient-pink" className="pt-12 pb-16 md:pt-16 md:pb-24 overflow-hidden" data-id="element-124">
      {/* Subtle Community Proof - Small avatars */}
      <motion.div className="flex flex-col items-center mb-6" initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.4
    }} data-id="element-125">
        <div className="flex -space-x-2 mb-2" data-id="element-126">
          <img src="https://i.pravatar.cc/150?img=1" alt="" className="w-10 h-10 rounded-full border-2 border-white shadow-sm" data-id="element-127" />
          <img src="https://i.pravatar.cc/150?img=5" alt="" className="w-10 h-10 rounded-full border-2 border-white shadow-sm" data-id="element-128" />
          <img src="https://i.pravatar.cc/150?img=9" alt="" className="w-10 h-10 rounded-full border-2 border-white shadow-sm" data-id="element-129" />
          <img src="https://i.pravatar.cc/150?img=10" alt="" className="w-10 h-10 rounded-full border-2 border-white shadow-sm" data-id="element-130" />
          <img src="https://i.pravatar.cc/150?img=20" alt="" className="w-10 h-10 rounded-full border-2 border-white shadow-sm" data-id="element-131" />
        </div>
        <p className="text-sm text-slate-600" data-id="element-132">
          Mujeres reales que ya forman parte de ENERGÍA REAL
        </p>
      </motion.div>

      <div className="text-center max-w-5xl mx-auto" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} data-id="element-134">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-slate-900 leading-tight mb-6 tracking-tight" data-id="element-135">
            ENERGÍA REAL
          </h1>

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-slate-800 mb-8 leading-snug max-w-4xl mx-auto" data-id="element-136">
            El método amable para mujeres de 25 a 40 que trabajan, estudian y
            sostienen la casa con la batería en rojo… y aun así tienen que
            seguir
          </h2>

          <div className="bg-white/60 backdrop-blur-sm p-6 rounded-2xl border border-fuchsia-100 max-w-3xl mx-auto mb-10" data-id="element-137">
            <p className="text-lg md:text-xl text-slate-700 leading-relaxed" data-id="element-138">
              No es falta de ganas. Es agotamiento profundo de vivir cumpliendo
              todo con fuerzas que no alcanzan.{' '}
              <span className="font-bold text-fuchsia-700" data-id="element-139">
                ENERGÍA REAL te ayuda a recuperar energía real sin exigirte más
                ni cambiar quién sos.
              </span>
            </p>
          </div>

          {/* Product Image */}
          <motion.div className="mb-10 flex justify-center" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.4,
          duration: 0.6
        }} data-id="element-140">
            <a href="#purchase-section" className="block relative group cursor-pointer" data-id="element-141">
              <div className="absolute -inset-8 bg-gradient-to-r from-fuchsia-300/40 to-pink-300/40 rounded-full blur-3xl group-hover:from-fuchsia-400/60 group-hover:to-pink-400/60 transition-all duration-500" data-id="element-142"></div>
              <img src="https://cdn.magicpatterns.com/uploads/7uboQsFcy5xinmt7NYeF57/Portada.png" alt="Energía Real - El método amable para dejar de estar agotada" className="relative w-full max-w-lg md:max-w-2xl rounded-3xl shadow-2xl transform group-hover:scale-105 transition-transform duration-500 border-4 border-fuchsia-200" data-id="element-143" />
            </a>
          </motion.div>

          {/* CTA Button */}
          <div className="flex flex-col items-center gap-4" data-id="element-144">
            <Button href="#purchase-section" variant="vibrant" size="xxl" className="w-full sm:w-auto shadow-2xl shadow-fuchsia-500/30 animate-pulse" data-id="element-145">
              👉 Quiero dejar de vivir con la batería en rojo
            </Button>
          </div>
        </motion.div>
      </div>
    </Section>;
}